<template>
  <Teleport :to="portalRootElementSelector">
    <ModalRoot v-model="isOpen" class="py-6">
      <template #body="{ close: closeModal }">
        <ModalBodyV2
          class="items-center !max-w-xl h-full max-h-[40rem] !px-4 sm:!px-7 !gap-8"
          @close="
            () => {
              closeModal();
              emit('closed');
            }
          "
        >
          <iframe
            v-if="requestedToken"
            class="w-full h-full border-none"
            :src="`https://app.socios.com/on-ramp-token?purchase_qty=${topUpBalance}&on_ramp_token=true&fiat_currency_code=USD&partnerWebAppId=${requestedToken.external_partner_id}`"
            allow="
              publickey-credentials-get https://app.socios.com https://gateway-capsicum.socios.com;
              publickey-credentials-create https://app.socios.com https://gateway-capsicum.socios.com;
            "
            allowpaymentrequest
            sandbox="allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts"
            referrerpolicy="no-referrer"
          ></iframe>

          <div v-else class="flex flex-col items-center gap-1">
            <WalletGraphic />
            <p
              class="font-medium text-text-secondary text-base text-center px-4"
            >
              {{ $t("common.errors.unexpectedError") }}
            </p>

            <ButtonV2
              variant="primary"
              size="lg"
              class="!font-sans !font-semibold"
              @click="closeModal"
            >
              {{ $t("common.close") }}
            </ButtonV2>
          </div>
        </ModalBodyV2>
      </template>
    </ModalRoot>
  </Teleport>
</template>

<script setup lang="ts">
import ModalBodyV2 from "@/components/ui/modal/modal-body-v2.vue";
import ModalRoot from "@/components/ui/modal/modal-root.vue";
import { useJustOneOpenModal } from "@/composables/buses/use-modal-bus";
import { portalRootElementSelector } from "@/constants/ui";
import type { WebThreeTokenWithBalance } from "@/constants/web-three";
import WalletGraphic from "./wallet-graphic.vue";
import ButtonV2 from "@/components/ui/button/button-v2.vue";

const emit = defineEmits<{
  closed: [];
}>();

defineProps<{
  requestedToken: WebThreeTokenWithBalance | null;
  topUpBalance: number | null;
}>();

const isOpen = defineModel<boolean>({
  required: true,
});

useJustOneOpenModal(isOpen);
</script>
